import Modal from 'components/modal';
import withModalActions from './withModalActions';

const withModal = (modalConfig) => (Component) =>
  withModalActions((props) => {
    const {
      closeModal,
      // eslint-disable-next-line no-unused-vars
      isModalOpen,
      modalState,
      ...rest
    } = props;

    return (
      <Modal {...modalConfig}>
        <Component
          closeModal={() => closeModal(modalConfig.modalId)}
          modalState={modalState(modalConfig.modalId)}
          {...rest}
        />
      </Modal>
    );
  });

export default withModal;
